import styled from 'styled-components/native';

import Text from '@components/Text';

export const Container = styled.View``;

export const LoadingImage = styled.Image`
  width: 50px;
  height: 16px;
`;

export const LoadingText = styled(Text)`
  font-family: ${props => props.theme.fonts.weight[500]};
  font-size: 13px;
`;
